import { Link } from 'react-router';
import { LayoutDashboard, Lock } from 'lucide-react';
import { useTranslations } from '@/i18n/use-locale';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { EmptyState } from '@/components/ui/empty-state';

/**
 * What an admin sees when they open a route their role does not cover.
 *
 * A panel rather than a silent redirect. Bouncing someone to the dashboard with no
 * explanation reads as a broken link, and the first thing they do is try again; saying
 * which seat they hold and that this screen needs a different one ends the question. The
 * page behind it is not rendered and its data is never fetched — the layout swaps this
 * in instead of `children` (ADR-007).
 */
export function ForbiddenScreen({ role }: { role: string }) {
  const t = useTranslations('admin.forbidden');

  return (
    <Card>
      <EmptyState
        icon={Lock}
        title={t('title')}
        hint={t('hint', { role })}
        action={
          <Button asChild variant="outline">
            <Link to="/admin">
              <LayoutDashboard aria-hidden className="h-4 w-4" />
              {t('backToOverview')}
            </Link>
          </Button>
        }
      />
    </Card>
  );
}
